import { GovernanceSpecificResultComponent } from '@agilelab/plugin-wb-governance';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { FC, ReactNode, useState } from 'react';

interface TestDetailDrawerProps {
  evaluationId: number | string;
  idType?: 'pk' | 'external';
  open: boolean;
  setOpen: () => void;
}

export const TestDetailDrawer: FC<TestDetailDrawerProps> = ({
  open,
  setOpen,
  evaluationId,
  idType,
}) => {
  const [title, setTitle] = useState<ReactNode>();

  return (
    <WbDrawer open={open} setOpen={setOpen} title="Test Details">
      <>
        {title}
        {evaluationId && (
          <GovernanceSpecificResultComponent
            evaluationId={evaluationId}
            idType={idType}
            setTitle={setTitle}
          />
        )}
      </>
    </WbDrawer>
  );
};
